import React from 'react'
import { withRouter } from 'react-router-dom';
import Single from './Single'

class Project extends Single{
    
    constructor(props){
        super(props)
        this._type = 'projet'
    }
    
}

export default withRouter(Project)


// WEBPACK FOOTER //
// ./src/components/Project.js